import { apiRequest } from './client'
import type { ChatChannel, ChatChannelMember, ChatMessage } from './types'

export const chatApi = {
  listChannels: () => apiRequest<{ data: ChatChannel[] }>('/chat/channels'),

  createChannel: (input: { name: string; isPrivate?: boolean; memberUserIds?: string[] }) =>
    apiRequest<{ data: ChatChannel }>('/chat/channels', { method: 'POST', body: input }),

  deleteChannel: (channelId: string) => apiRequest<{ data: { success: boolean } }>(`/chat/channels/${channelId}`, { method: 'DELETE' }),

  listMembers: (channelId: string) => apiRequest<{ data: ChatChannelMember[] }>(`/chat/channels/${channelId}/members`),

  setMembers: (channelId: string, userIds: string[]) =>
    apiRequest<{ data: ChatChannelMember[] }>(`/chat/channels/${channelId}/members`, { method: 'PATCH', body: { userIds } }),

  listMessages: (channelId: string, before?: string) =>
    apiRequest<{ data: ChatMessage[] }>(`/chat/channels/${channelId}/messages`, { query: { before, limit: 50 } }),

  markRead: (channelId: string) => apiRequest<{ data: { success: boolean } }>(`/chat/channels/${channelId}/read`, { method: 'POST', body: {} }),

  unreadCounts: () => apiRequest<{ data: Record<string, number> }>('/chat/unread-counts'),
}
